import { useState, useEffect } from 'react';
import { Table, Row, Col, Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { getLogs } from '../../services/Items/Inventory';
import { useNavigate } from 'react-router-dom';

function renderUser(u) {
    if (u == null) return 'Sistema';
    if (typeof u === 'string') return u;
    if (typeof u === 'number') return `Usuario #${u}`;
    if (u.userName && u.email) return `${u.userName} - ${u.email}`;
    return u.userName || u.email || 'Sistema';
}

function ItemLogsModal({ show, handleClose, id, handleBack }) {
    const navigate = useNavigate();
    const [data, setData] = useState([]);

    const handleEdit = () => navigate(`/editItem/${id}`);

    useEffect(() => {
        if (!show || !id) return;
        getLogs(id).then(setData).catch(() => setData([]));
    }, [id, show]);

    return (
        <Modal size="lg" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Historial de movimientos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {(data?.length ?? 0) > 0 ? (
                    data.map((item, index) => {
                        // user puede venir como:
                        // - item.userLabel (si lo normalizas), o
                        // - item.user (string/number/obj), o
                        // - item.iUsers (objeto con userName/email)
                        const userObj = item.userLabel ?? renderUser(item.user ?? item.iUsers ?? null);
                        const userText = typeof userObj === 'string' ? userObj : renderUser(userObj);

                        // campos pueden venir como:
                        // - item.ilFields (logs clásicos)
                        // - item.fields (cuando viene del kardex)
                        const fields = item.ilFields ?? item.fields ?? [];

                        return (
                            <Row key={`log-${item.id ?? index}`}>
                                <Col xl={12}>
                                    <Table className="mb-5 mt-3" bordered hover responsive>
                                        <thead>
                                            <tr className="table-dark">
                                                <th className="text-center">
                                                    Quien realizó el movimiento:
                                                    <br />
                                                    {userText}
                                                </th>
                                                <th className="text-center">
                                                    Cuando se realizó el movimiento:
                                                    <br />
                                                    {item.createdAtFormatted ?? item.created_at_formatted ?? '-'}
                                                </th>
                                                <th className="text-center">
                                                    {item.info ?? ''}
                                                </th>
                                            </tr>
                                            <tr className="table-secondary">
                                                <th className="text-center">Campo</th>
                                                <th className="text-center">Valor viejo</th>
                                                <th className="text-center">Valor nuevo</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {(fields ?? []).length > 0 ? (
                                                (fields ?? []).map((subItem, i2) => (
                                                    <tr key={`field-${item.id ?? index}-${i2}`}>
                                                        <td className="bg-light text-center">
                                                            {subItem.field ?? subItem.fieldName ?? '-'}
                                                        </td>
                                                        <td className="text-center">
                                                            {subItem.old ?? subItem.oldValue ?? '-'}
                                                        </td>
                                                        <td className="text-center">
                                                            {subItem.new ?? subItem.newValue ?? '-'}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={3} className="text-center">
                                                        Sin cambios de campos registrados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        );
                    })
                ) : (
                    <h6>No hay movimientos</h6>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleBack}>
                    Regresar
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
                {/* Si quieres editar desde aquí */}
                {/* <Button variant="primary" onClick={handleEdit}>Editar</Button>  */}
            </Modal.Footer>
        </Modal>
    );
}

export default ItemLogsModal;